export default () => {
  const headerScript = document.createElement('script')
  headerScript.setAttribute('src', 'https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver')
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(headerScript)
}
